import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceManagerService } from '../service-manager.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  profileData: any;
  constructor(public router: Router, public serviceManager: ServiceManagerService) { 
    this.serviceManager.CallBackendServiceAPI('get-profile-details', {}).subscribe( (data: any)=>{
      if(data){
        this.profileData = data["profile_details"]
      }
    }) 
  }

  ngOnInit(): void {
    
  }

  navToPage(param: any){
    this.router.navigate(['/update-admin'], { queryParams: {change: param}})

  }

}
